<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.opinion.updatedAndMadePublicByOrg.p1')}}
    {{ news.textParams[2] }}
    {{ news.textParams[3] }}
    {{ news.textParams[4] }}
    {{ news.textParams[5] }}
    {{ news.textParams[6] }}
    {{ news.textParams[7] }}
    {{ news.textParams[8] }}
    {{$t('news.template.opinion.updatedAndMadePublicByOrg.p2')}}
    {{ news.textParams[9] }}
    {{$t('news.template.opinion.updatedAndMadePublicByOrg.p3')}}
    "<router-link :to="{name: 'OpinionView', params: {hash: news.textParams[10]}}"
    >{{ news.textParams[11] }}
    </router-link>"
    {{$t('news.template.opinion.updatedAndMadePublicByOrg.p4')}}
  </div>
</template>
